<template>
  <div
    :style="`min-width:${
      barChartRankingVisitantes.chartData.labels.length * 8
    }px;max-width:100%;`"
  >
    <horizontalBar-chart
      id="horizontalBar-chart-ranking-visitantes"
      :height="250"
      :chart-data="barChartRankingVisitantes.chartData"
      :extra-options="barChartRankingVisitantes.extraOptions"
    >
    </horizontalBar-chart>
  </div>
</template>

<script>
import HorizontalBarChart from '@/components/Charts/HorizontalBarChart'
import defaultChartObjects from '../defaultChartObjects'
import { mapActions, mapGetters } from 'vuex'

export default {
  component: 'BarChartRankingVisitantes',

  components: {
    HorizontalBarChart,
  },

  props: {
    defaultBarThickness: {
      type: Number,
      default: 8,
    },

    maxBarThickness: {
      type: Number,
      default: 30,
    },

    colors: {
      type: Array,
      default: [],
    },

    fetchProgress: {
      type: Number,
      default: 0 | 100,
    },

    filteredDataCharts: {
      type: Array,
      default: [],
    },

    filteredbillItensList: {
      type: Array,
      default: [],
    },

    selectedbillItensNames: {
      type: Array,
      default: [],
    },

    verticalChartMaxLines: {
      type: Number,
      default: 20,
    },
  },

  data: () => {
    return {
      // defaultChart: defaultObject,
    }
  },

  created() {
    this.filteredDataCharts.forEach((booking) => {
      if (
        !this.filteredbillItensList.some(
          (item) => item.uuid == booking.poi.uuid
        )
      ) {
        this.filteredbillItensList.push({
          name: booking.poi.name,
          uuid: booking.poi.uuid,
        })
      }
    })
  },
  computed: {
    ...mapGetters('product', {
      useChartCache: 'getUseChartCache',
      cacheObject: 'getBarChartRankingVisitantes',
    }),

    barChartRankingVisitantes() {
      var defaultChart = {}
      var labels = []

      defaultChart = JSON.parse(
        JSON.stringify(defaultChartObjects.defaultBarChartRankingVisitantes)
      )
      if (
        this.useChartCache &&
        this.cacheObject.chartData != undefined &&
        this.cacheObject.chartData.labels.length > 0
      ) {
        defaultChart = JSON.parse(JSON.stringify(this.cacheObject))
      }

      if (this.fetchProgress == 100 && this.filteredDataCharts.length > 0) {
        labels = [
          ...this.filteredbillItensList,
          { name: 'Outro Local', uuid: '' },
        ]
        var arrayInfo = new Array(labels.length).fill(0)
        var chartTotalCount = 0

        this.filteredDataCharts.map(function (booking, idx) {
          var count = booking.people.tableText.count
          var productIndex = labels.findIndex(
            (productLabel) => productLabel.uuid == booking.poi.uuid
          )

          if (productIndex >= 0) {
            arrayInfo[productIndex] = arrayInfo[productIndex] + count
            chartTotalCount += count
          } else {
            productIndex = labels.findIndex(
              (productLabel) => productLabel.name == 'Outro Local'
            )
            arrayInfo[productIndex] = arrayInfo[productIndex] + count
            chartTotalCount += count
          }
        })

        labels.forEach(function (booking, idx) {
          var qntd = arrayInfo[idx]
          arrayInfo[idx] = {
            label:
              booking.name +
              ' (' +
              ((qntd * 100) / chartTotalCount).toFixed(2).replace('.', ',') +
              '%)',
            amount: qntd,
          }
        })

        arrayInfo.sort(function (a, b) {
          return a.amount < b.amount ? -1 : a.amount > b.amount ? 1 : 0
        })
        arrayInfo.reverse()

        let otherProductIndex = labels.findIndex(
          (productLabel) => productLabel.name == 'Outro Local'
        )
        if (arrayInfo[otherProductIndex] === 0) {
          labels.splice(otherProductIndex, 1)
        }

        otherProductIndex = arrayInfo.findIndex(
          (productLabel) => productLabel.label.indexOf('Outro Local') !== -1
        )
        if (otherProductIndex !== -1) {
          arrayInfo.splice(otherProductIndex, 1)
        }

        const arrayAmount = arrayInfo
          .slice(0, this.verticalChartMaxLines)
          .map(function (val, idx) {
            return val.amount
          }) //VALOR DA QNTD DE VISITANTE POR PERIODO
        const arrayLabels = arrayInfo
          .slice(0, this.verticalChartMaxLines)
          .map(function (val, idx) {
            return val.label
          }) //NOMES DOS LABELS DO PERIODO

        defaultChart.chartData = {
          labels: arrayLabels,
          datasets: [
            {
              label: 'Qntd. no período',
              data: arrayAmount,
              backgroundColor: this.colors,
              barThickness: this.defaultBarThickness,
              maxBarThickness: this.maxBarThickness,
            },
          ],
        }

        defaultChart.extraOptions = {
          legend: { display: false },
          tooltips: {
            mode: 'point',
            callbacks: {
              label: function (tooltipItem, data) {
                return (
                  data.labels[tooltipItem.index] +
                  ': ' +
                  data.datasets[0]['data'][tooltipItem.index] +
                  ' visitantes'
                )
              },
            },
          },
        }

        if (this.useChartCache == true && this.fetchProgress == 100) {
          this.productStoreCommit({
            mutation: 'SET_BAR_CHART_RANKING_VISITANTES',
            value: JSON.parse(JSON.stringify(defaultChart)),
          })
        }
      }

      return defaultChart
    },
  },

  methods: {
    ...mapActions('product', ['productStoreCommit']),
  },
}
</script>
